<style scoped>
.modal-create-task {
  overflow-y: auto !important;
}

.modal-create-task {
  width: 90vw;
  height: 90vh !important;
}



.p-select {
  width: 100%;
}

.p-textarea {
  background: #fff;
  width: 100% !important;
}

.p-editor .p-editor-content.ql-disabled .ql-editor {
  background: var(--p-select-disabled-background)
}

label {
  font-size: var(--p-floatlabel-active-font-size);
  font-weight: var(--p-floatlabel-label-active-font-weight);
}


.p-message-error {
  color: #dc2626;
  font-size: 14px;
}

.p-message-content {
  height: fit-content !important;
}

.col-bottoni {
  display: flex;
  grid-column-gap: 20px;
  justify-content: end;
}

.close {
  text-align: right;
  margin-bottom: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.card-body {
  position: relative;
  padding: 20px;
}
.custom-row{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  grid-column-gap: 20px;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position modal-create-task">
    <div class="card mb-4">
      <div class="card-body">
        <div class="close" @click="annulla()">
          <i class="pi pi-times" style="font-size: 20px"></i>
        </div>
        <h4>{{ titolo }}</h4>
        <CustomForm v-slot="$form" :resolver="resolver" :initialValues="initialValues" @submit="onFormSubmit"
          class="flex flex-col gap-4 w-full md:w-56" style="margin-top: 30px;">
          <div class="row">
            <div class="col-12">

              <div class="custom-row">
                <div class="flex flex-col gap-1" style="width: calc(50% - 45px)">
                  <FloatLabel variant="on" class="w-full md:w-56">
                    <CustomSelect filter :virtualScrollerOptions="{ itemSize: 38 }" name="lavoro" showClear
                                  :options="lavori" @change="lavoroSelected($form)" optionLabel="titolo" :disabled="modifica ||readonlyLavori"
                                  optionValue="id_ticket" :loading="lavori.length <= 0" />
                    <label for="over_label">Lavoro</label>
                  </FloatLabel>
                  <Message v-if="$form.lavoro?.invalid" severity="error" variant="simple" size="small">Selezionare un
                    lavoro</Message>
                </div>
                <div class="flex flex-col gap-1" style="width: calc(50% - 45px)">
                  <FloatLabel variant="on" class="w-full md:w-56">
                    <CustomSelect :virtualScrollerOptions="{ itemSize: 38 }" filter name="attivita" showClear
                                  :options="attivita" :disabled="modifica ||readonlyLavori" optionLabel="titolo" optionValue="id_ticket"
                    >
                      <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->
                      <template #footer>
                        <div class="p-3" v-if="$form.lavoro?.value">
                          <CustomButton label="Crea attività" fluid severity="secondary" text size="small" icon="pi pi-plus" @click="creaAttivita($form.lavoro)" />
                        </div>
                      </template>
                    </CustomSelect>
                    <label for="over_label">Attività</label>
                  </FloatLabel>
                  <Message v-if="$form.attivita?.invalid" severity="error" variant="simple" size="small">Selezionare
                    un'attività</Message>
                </div>

                <div class="flex flex-col gap-1" style="text-align: right; width: 45px">
                  <CustomButton severity="primary"  icon="pi pi-plus" @click="creaAttivita($form.lavoro)" :disabled="modifica"></CustomButton>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 mt-10">
              <div class="flex flex-col gap-1">
                <FloatLabel variant="on" class="w-full md:w-56">
                  <InputNumber name="caricoOre" inputId="integeronly" fluid
                    :disabled="!$form?.attivita?.value || $form?.attivita?.invalid" />
                  <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->
                  <label for="over_label">Carico ore previsto</label>
                </FloatLabel>
              </div>
            </div>
            <div class="col-md-3 6 mt-10">
              <div class="flex flex-col gap-1">
                <div style="display: flex; flex-direction: column;">
                  <label for="over_label">Richiede l'approvazione del PM per il completamento</label>
                  <ToggleSwitch name="richiedeApprovazione" />
                </div>
              </div>
            </div>

            <div class="col-md-3 6 mt-10">
              <div class="flex flex-col gap-1">
                <FloatLabel variant="on" class="w-full md:w-56">
                  <DatePicker :disabled="modifica||daProgrammare" name="dataInizio" fluid dateFormat="dd/mm/yy" />
                  <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->
                  <label for="over_label">Data inizio del Task</label>
                </FloatLabel>
              </div>
            </div>
            <div class="col-12 mt-10" >
              <div class="flex flex-col gap-1">
                <div style="display: flex; flex-direction: column;">
                  <label for="over_label">Imposta PM per il task sprint</label>
                  <ToggleSwitch name="forzaPM" :disabled="!$form?.attivita?.value || $form?.attivita?.invalid" />
                </div>
              </div>
              <div class="flex flex-col gap-1 mt-5" v-show="$form.forzaPM?.value===true">
                <FloatLabel variant="on" class="w-full md:w-56">
                  <CustomSelect filter name="pm" :options="pmDisponibili" optionLabel="descrizione" optionValue="id_account" :loading="pmDisponibili.length<=0" :disabled="!$form?.attivita?.value || $form?.attivita?.invalid"  />
                  <label for="over_label">PM responsabile</label>
                </FloatLabel>
                <Message v-if="$form.lavoro?.invalid" severity="error" variant="simple" size="small">Selezionare un
                  lavoro</Message>
              </div>
            </div>

            <div class="col-12 mt-10">
              <div class="flex flex-col gap-1" style="display: flex; flex-direction: column;">
                <FloatLabel variant="on" class="w-full">
                  <CustomTextArea name="DOD" rows="5" cols="10"
                    :disabled="!$form?.attivita?.value || $form?.attivita?.invalid"  />
                  <label for="over_label">DOD</label>
                </FloatLabel>
                <Message v-if="$form.DOD?.invalid" severity="error" variant="simple" size="small">Inserire una DOD
                </Message>
              </div>
            </div>

            <div class="col-12 mt-5 col-bottoni">
              <CustomButton v-if="daProgrammare" severity="primary" label="Programma per la settimana in corso" @click="programmaSettimana($form)"></CustomButton>
              <CustomButton v-if="daProgrammare" severity="primary" label="Programma per la prossima settimana" @click="programmaProssimaSettimana($form)"></CustomButton>
              <CustomButton v-if="!daProgrammare" type="submit" severity="primary" :label="btnLabel"></CustomButton>
              <CustomButton @click="annulla()" severity="secondary" label="Annulla"></CustomButton>
            </div>
          </div>
        </CustomForm>
      </div>
    </div>
  </div>
</template>
<script>
import ToggleSwitch from 'primevue/toggleswitch';
import CustomButton from 'primevue/button';
import Message from 'primevue/message';
import CustomTextArea from 'primevue/textarea';
import InputNumber from 'primevue/inputnumber';
import CustomSelect from 'primevue/select';
import { Form as CustomForm } from '@primevue/forms';
import FloatLabel from 'primevue/floatlabel';
import * as $ from 'jquery';
import { ref } from 'vue';
import DatePicker from 'primevue/datepicker';
import { useSlots } from 'vue';
import VirtualScroller from 'primevue/virtualscroller';
import moment from "moment/moment";
export default {
  name: "KModalCreaTaskSprint",
  components: { CustomForm, CustomSelect, FloatLabel, InputNumber, Message, CustomTextArea, CustomButton, ToggleSwitch,DatePicker },
  data() {
    return {
      titolo:'Crea nuovo Task Sprint',
      btnLabel: 'Crea Task Sprint',
      userId: -1,
      status: '',
      lavori: [],
      attivita: [{
        cache_titolo: '',
        id_ticket: -1
      }],
      modifica: false,
      $form: ref(),
      taskDaDuplicare: null,
      show: false,
      duplication:false,
      originalTaskId:null,
      initialValues: ref({
        dataInizio: new Date()
      }),
      images:[],
      daProgrammare:false,
      taskDaProgrammare:null,
      readonlyLavori:false,
      pmDisponibili:[],
    }
  },
  setup() {
    return {
    }
  },
  mounted() {
    this.$form=ref();
  },
  created() {

    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla();
      }
    }.bind(this));

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'creaTaskSprint') {
        this.duplication=false;
        this.originalTaskId=null;
        this.pmDisponibili= [...this.$store.getters.getEsecutori()];

        if (this.$store.getters.getLavori() !== false) {
          this.lavori = [...this.$store.getters.getLavori()];
        }
        if (this.$store.getters.getAttivitaSenzaLavoro() !== false) {
          this.attivita = [...this.$store.getters.getAttivitaSenzaLavoro()];
        }
        $('html').css('overflow', 'hidden')
        this.show = true;
        this.userId = mutation.payload.userId;
        this.status = mutation.payload.status;
        this.initialValues = {
          dataInizio: new Date()
        }
        let esecutore= this.$store.getters.getEsecutoriFilter(this.userId+"");
        this.titolo='Crea nuovo Task Sprint per '+esecutore[0]?.descrizione ;

        // this.$store.dispatch('loadLavori');
        // this.$store.dispatch('loadAttivitaSenzaLavoro');
        if (mutation.payload.duplica) {
          this.duplication=true;
          this.originalTaskId=mutation.payload.task.id;
          console.log(mutation.payload.task)
          this.taskDaDuplicare = { ...mutation.payload.task };
          this.initialValues.DOD = this.taskDaDuplicare.descrizione;
          this.initialValues.richiedeApprovazione = this.taskDaDuplicare.richiedeApprovazione;
          this.initialValues.caricoOre = this.taskDaDuplicare.orePreviste;
          this.initialValues.dataInizio=moment.unix(this.taskDaDuplicare.startDate).toDate()
          if (this.taskDaDuplicare.idTicketParent > 0) {
            this.initialValues.lavoro = this.taskDaDuplicare.idTicketParent;
            this.attivita = this.$store.getters.getAttivitaLavoro(this.taskDaDuplicare.idTicketParent)
          } else {
            this.attivita = [...this.$store.getters.getAttivitaSenzaLavoro()];
          }

          if(this.taskDaDuplicare.forcePM===true){
            this.initialValues.forzaPM=true;
            this.initialValues.pm=this.taskDaDuplicare.idPmForzato+"";
          }

          this.initialValues.attivita = this.taskDaDuplicare.idTicket;
        }

        if (mutation.payload.modifica) {
          this.titolo='Modifica Task Sprint'
          this.modifica = true;
          this.taskDaDuplicare = { ...mutation.payload.task };
          this.initialValues.DOD = this.taskDaDuplicare.descrizione;
          this.initialValues.richiedeApprovazione = this.taskDaDuplicare.richiedeApprovazione;
          this.initialValues.caricoOre = this.taskDaDuplicare.orePreviste;
          this.initialValues.dataInizio=moment.unix(this.taskDaDuplicare.startDate).toDate()
          if (this.taskDaDuplicare.idTicketParent > 0) {
            this.initialValues.lavoro = this.taskDaDuplicare.idTicketParent;
            this.attivita = this.$store.getters.getAttivitaLavoro(this.taskDaDuplicare.idTicketParent)
          } else {
            this.attivita = [...this.$store.getters.getAttivitaSenzaLavoro()];
          }
          this.btnLabel = 'Conferma modifica'
          this.initialValues.attivita = this.taskDaDuplicare.idTicket;
          if(this.taskDaDuplicare.forcePM===true){
            this.initialValues.forzaPM=true;
            this.initialValues.pm=this.taskDaDuplicare.idPmForzato+"";
          }

          this.daProgrammare=mutation.payload.daProgrammare||false;
        }
        if (mutation.payload.creaDaAttivita) {
          let attivita=mutation.payload;
          this.titolo='Crea nuovo Task Sprint per '+esecutore[0]?.descrizione ;
          if (attivita.id_ticket_first_padre > 0) {

            if(this.lavori.length<0||this.lavori.findIndex(lav=>lav.id_ticket==attivita.id_ticket_first_padre)<0){
              this.readonlyLavori=true;
              this.lavori.push({
                id_ticket:attivita.id_ticket_first_padre,
                titolo:attivita.lavoro
              })
            }

            this.initialValues.lavoro = attivita.id_ticket_first_padre;
            this.attivita = this.$store.getters.getAttivitaLavoro(attivita.id_ticket_first_padre)
          } else {
            this.attivita = [...this.$store.getters.getAttivitaSenzaLavoro()];
          }
          this.btnLabel = 'Crea Task Sprint'
          this.initialValues.attivita = attivita.id_ticket;
          this.daProgrammare=false;
        }
      }

      // if (mutation.type === 'lavoriCaricati') {
      //   this.lavori=[...mutation.payload];
      //   if(this.taskDaDuplicare && this.taskDaDuplicare.idTicketParent>0){
      //     this.$store.dispatch('loadAttivitaLavoro', {
      //       idTicket:this.taskDaDuplicare.idTicketParent
      //     });
      //   }
      // }

      if (mutation.type === 'attivitaSenzaLavoroCaricate') {
        this.attivita = [...mutation.payload];
        if (this.taskDaDuplicare && this.taskDaDuplicare.idTicketParent <= 0) {
          this.initialValues.attivita = this.taskDaDuplicare.idTicket;
        }
      }

      if (mutation.type === 'attivitaLavoroCaricate') {
        this.attivita = [...mutation.payload];
      }

      if (mutation.type === 'tasksCreated' || mutation.type === 'tasksUpdated') {
        this.annulla()
      }

      if(mutation.type==='attivitaCreata'){
        this.show=true;
        this.initialValues.lavoro = mutation.payload?.id_ticket_first_padre;
        this.attivita = this.$store.getters.getAttivitaLavoro(mutation.payload?.id_ticket_first_padre)
        this.initialValues.attivita = mutation.payload?.id_ticket;
      }
    });
  },
  methods: {


    // onPaste(event) {
    //   const items = (event.clipboardData || event.originalEvent.clipboardData).items;
    //
    //   for (const item of items) {
    //     if (item.type.startsWith("image/")) {
    //       const file = item.getAsFile();
    //       const reader = new FileReader();
    //
    //       reader.onload = (e) => {
    //         this.images.push(e.target.result); // Salva l'immagine in base64
    //         console.log(e)
    //       };
    //
    //       reader.readAsDataURL(file);
    //     }
    //   }
    // },

    resolver: ({ values }) => {
      const errors = {};
      if (!values.lavoro && !values.attivita) {
        errors.lavoro = [{ message: 'Lavoro is required.' }];
      }
      if (values.lavoro && !values.attivita) {
        errors.attivita = [{ message: 'Attività is required.' }];
      }
      if (values.attivita) {
        errors.lavoro = undefined;
      }
      if (!values.DOD) {
        errors.DOD = [{ message: 'Inserire una DOD.' }];
      }
      return {
        errors
      };
    },
    onFormSubmit({ values, states, valid, errors }) {
      if (valid) {
        let nuovoTaskSprint = {
          idTicket: states.attivita.value,
          idTicketParent: states.lavoro.value,
          orePreviste: states.caricoOre.value,
          status: this.status,
          idOwner: this.userId,
          descrizione: states.DOD.value,
          richiedeApprovazione: states.richiedeApprovazione.value,
          startDate:moment(states.dataInizio.value).unix(),
          duplication:this.duplication,
          originalTaskId:this.originalTaskId
        }

        if(states.forzaPM.value===true){
          nuovoTaskSprint.forcePM=true;
          nuovoTaskSprint.idPmForzato=states.pm.value
        }

        if (states.lavoro.value) {
          let lavoro = this.$store.getters.getLavoroTicket(states.lavoro.value);
          if (lavoro.length > 0){
            nuovoTaskSprint.titoloLavoro = lavoro[0].titolo;
            nuovoTaskSprint.idAnagraficaRelazione=lavoro[0].id_anagrafica_relazione
            nuovoTaskSprint.labelAnagraficaRelazione=lavoro[0].id_anagrafica_relazione_lbl
          }
        }
        if (states.attivita.value) {
          let attivita = this.$store.getters.getTicket(states.attivita.value);
          if (attivita.length > 0){
            nuovoTaskSprint.titoloAttivita = attivita[0].titolo;
            nuovoTaskSprint.idAnagraficaRelazione=attivita[0].id_anagrafica_relazione
            nuovoTaskSprint.labelAnagraficaRelazione=attivita[0].id_anagrafica_relazione_lbl;
            nuovoTaskSprint.idTicketCategoria=attivita[0].categoria_ticket_id;
          }

        }
        if (this.modifica === true) {
          nuovoTaskSprint.id = this.taskDaDuplicare.id;
          nuovoTaskSprint.oldDescrizione = this.taskDaDuplicare.descrizione;
          nuovoTaskSprint.idTicketCategoria=this.taskDaDuplicare.idTicketCategoria
          if(!this.daProgrammare){
            nuovoTaskSprint.startDate=undefined;
            this.$store.dispatch('editTask', { ...nuovoTaskSprint });
          }else{
            this.$store.dispatch('editTask', { ...nuovoTaskSprint });
            setTimeout(()=>{
              this.$store.dispatch("updateStatus", {
                ...nuovoTaskSprint, taskStatus:'TODO', oldStatus: 'BACKLOG', prossimaSettimana:states.isProssimaSettimana
              });
            },1000)
            this.readonlyLavori=false;
          }
        } else {
          this.$store.dispatch('createTask', { ...nuovoTaskSprint });
          this.readonlyLavori=false;
        }
      }
    },
    programmaSettimana(form){
      if(form.valid){
        let obj={
          valid:form.valid,
          states:{...form, isProssimaSettimana:false}
        }
        this.onFormSubmit(obj)
      }
    },
    programmaProssimaSettimana(form){
      if(form.valid){
        let obj={
          valid:form.valid,
          states:{...form, isProssimaSettimana:true}
        }
        this.onFormSubmit(obj)
      }
    },
    annulla() {
      this.show = false;
      this.userId = -1;
      this.status = "";
      this.modifica = false;
      this.daProgrammare=false;
      this.btnLabel = 'Crea Task Sprint';
      $('html').css('overflow', 'auto');
      let tasks = this.$store.getters.getAllTasks();
      this.$store.dispatch("tasksLoaded", tasks);
    },

    creaAttivita(lavoroSelezionato){
      this.show=false;
      this.$store.dispatch('creaAttivita', {
        idLavoro:lavoroSelezionato.value,
        idEsecutore:this.userId
      });
    },

    lavoroSelected(form) {
      this.attivita = [];
      form.attivita.value = undefined;
      if (form?.lavoro?.value) {

        this.attivita = [...this.$store.getters.getAttivitaLavoro(form?.lavoro?.value)];

        // this.$store.dispatch('loadAttivitaLavoro', {
        //   idTicket:form?.lavoro?.value
        // });
      } else {
        this.attivita = [...this.$store.getters.getAttivitaSenzaLavoro()];
      }

      // this.$store.dispatch('loadAttivitaLavoro',{
      //   idTicket:form?.lavoro?.value
      // });
    }
  }
}
</script>